import { useEffect, useState } from 'react';
import { getSubjectRoster } from '../services/gradesService';

export function useSubjectRoster(gradeLevel, sections) {
  const [roster, setRoster] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Joined so the effect depends on the section names, not the array's identity.
  const sectionsKey = sections.join('|');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');

    getSubjectRoster(gradeLevel, sectionsKey ? sectionsKey.split('|') : [])
      .then((result) => {
        if (mounted) setRoster(result);
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load students');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [gradeLevel, sectionsKey]);

  return { roster, loading, error };
}
